import React from "react";

type FaqContextType = {};

const defaultValue: FaqContextType = {};

export const FaqContext = React.createContext(defaultValue);

export default function AlarmContextProvider(props: {
  children: React.ReactNode;
}) {
  return <FaqContext.Provider value={{}}>{props.children}</FaqContext.Provider>;
}
